<template>
	<div>
		<h2>Propiedades</h2>
		<br>
		<a @click="$router.go(-1)">regresar</a>
		<br>
		<br>
		<input type='text' placeholder='BUSCAR' v-model='abuscar'  >
		<br>
		<br>

		<router-link id='agrega' :to="{name: 'agre-propi'}">Agregar</router-link>
		<br>

		<table class="table is-striped is-hoverable" id='inquilinos-lista' v-if="propiedadesTodas !=null" align="center"  >
			<tbody >
				<tr>	
					<th>Familia/SubF</th>
					<th>Dueño</th>
					<th>Nombre</th>
					<th>Calle</th>
					<th>Num.</th>
					<th>M2</th>
					<th>Tipo</th>
					<th>Renta</th>
					<th>Saldo</th>
					<th>Fecha saldo</th>
					<th>Status</th>

				</tr>

				<tr v-for="propi in buscando">

					<td>{{propi.familia}}<br> {{propi.subfamilia}}  <br> Id:{{propi.id}}</td>
					<td>{{propi.dueno}} </td>
					<td>{{propi.nombreCompleto}}</td>
					<td>{{propi.dirCalle}}</td>
					<td>{{propi.dirNumero}}</td>
					<td>{{propi.metrosCuadrados}}</td>
					<td>{{propi.tipo}}</td>
					<td>{{formateaNumero(propi.ultimaRenta)}}</td>
					<td>{{formateaNumero(propi.saldo)}}</td>
					<td>{{propi.fechaSaldo}}</td>
                    <td v-if="propi.status == 'DISPONIBLE'">
                        <b>{{propi.status}}<br> {{propi.giro}}</b></td>
					<td v-else>{{propi.status}}<br> {{propi.giro}}</td>

				    <td>
						<router-link id='ver' :to="{name: 'ver-propi', params:{id:propi.id}}">Ver</router-link>
					</td>
					<td>
						<router-link id='editar' :to="{name: 'edi-propi', params:{id:propi.id}}">Editar</router-link>
				    </td>
                    <td>
                        <router-link id='editar' :to="{name: 'edi-propi', params:{id:propi.id}}">Crear QR</router-link>
                    </td>
				</tr>
			</tbody>
		</table>
		
		<span v-else><button class="button is-primary is-loading">Loading</button></span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Propiedades',
  mounted(){
  	 this.getPropiedades();
  },
  props: ['vector', 'empresa'],  
  data () {
    return {
      propiedadesTodas: null,
      abuscar:''
    }
  },
  methods:{
  	getPropiedades(){
  		// checa si tiene autorizacion
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(!this.vector.includes('Propiedades')){
	  			alert('Seccion no autorizada');
	  			return;
	  		}
	  	}

  		axios.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php')
  		     .then((respuesta) => {
  		     	this.propiedadesTodas=respuesta.data;
  			 });
  	},

  	formateaNumero(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    }

  },

   computed:{
	 	buscando: function (){
	  		return this.propiedadesTodas.filter((item) =>  item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.subfamilia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.dueno.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.nombreCompleto.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.dirCalle.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.dirNumero.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.tipo.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.status.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  		);
	  	}
	}

}

</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/Propiedades.vue